import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./AboutUs.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { t } from "../../locales/i18n";
import Header from "../../components/Header/Header";
import { Helmet } from "react-helmet";
import BookNowBtn from "../../components/BookNowBtn";
import FooterInfo from "../../components/FooterInfo/FooterInfo";
import FloatingButton from "../../components/FloatingButton/FloatingButton";
import { ReactPhotoCollage } from "react-photo-collage";
import { images } from "../../assets/img";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

const PHOTOS = [
  { source: images.nail1 },
  { source: images.nail2 },
  { source: images.nail6 },
  { source: images.nail3 },
  { source: images.nail4 },
  { source: images.nail5 },
  { source: images.nail6 },
];

const AboutUs = () => {
  const navigate = useNavigate();
  const isMobile = useCheckIsMobile();
  const [collageLayout, setCollageLayout] = useState([]);
  const [collageHeight, setCollageHeight] = useState([]);

  useEffect(() => {
    const { layout, height } = generateLayoutAndHeight(PHOTOS.length) || {};
    setCollageLayout(layout);
    setCollageHeight(height);
  }, []);

  function generateLayoutAndHeight(imageCount) {
    const mobileHeightRange = { min: 23, max: 36 };
    const otherHeightRange = { min: 30, max: 47 };

    // Function to generate random numbers between a range
    const getRandomInRange = (min, max) =>
      Math.floor(Math.random() * (max - min + 1)) + min;

    // Function to generate random layout arrays
    const getRandomLayout = (isMobile) => {
      const maxItems = isMobile ? 3 : 4; // max 3 for mobile, 4 for others
      const layout = [];
      let totalImages = 0;

      while (totalImages < imageCount) {
        const numItems = getRandomInRange(1, maxItems);
        layout.push(numItems);
        totalImages += numItems;
      }
      return layout;
    };

    // Get randomized layout array
    const layout = getRandomLayout(isMobile);

    // Generate matching height array based on the layout
    const height = layout.map(() => {
      return isMobile
        ? `${getRandomInRange(mobileHeightRange.min, mobileHeightRange.max)}rem`
        : `${getRandomInRange(otherHeightRange.min, otherHeightRange.max)}rem`;
    });

    return { layout, height };
  }

  return (
    <div className={classes.container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"About us"}</title>
        <meta name="about-us" content="About us" />
      </Helmet>
      <Header selected={"about-us"} />

      <div className={classes.introTextContainer}>
        <div>
          <h1>
            {"Happy Nails Great Barr - Your go-to nail salon in Great Barr"}
          </h1>
          {/* <h3 className={classes.greyIntroTextContainer}>
             Happy Nails Great Barr - Your go-to nail salon in Great Barr
            </h3> */}
        </div>
        <p className={classes.greyIntroTextContainer}>
          Happy Nails Great Barr is your premier nail salon in Great Barr,
          Birmingham, located at 12 Birmingham Rd, B43 6NR. We specialise in
          professional manicure, pedicure, gel nails, acrylic nails, and bespoke
          nail art. Our skilled nail technicians deliver flawless results in a
          friendly and relaxing atmosphere, making us the top choice for nail
          care in Great Barr. Visit us for beautiful nails that last and an
          experience you’ll love.
        </p>
        <p className={classes.greyIntroTextContainer}>
          Whether you’re looking for a quick polish change, a luxury spa
          pedicure, or eye-catching nail art designs, our Great Barr nail salon
          has something for everyone. Using high-quality products and the latest
          techniques, we ensure your nails not only look stunning but also stay
          healthy. Conveniently located near local shops and with free parking
          available, Happy Nails Great Barr is the perfect spot to treat
          yourself. Book your appointment today and see why we’re one of the
          most recommended nail salons in Birmingham B43
        </p>
      </div>

      {collageLayout && collageLayout.length > 0 && (
        <ReactPhotoCollage
          width={"100%"}
          layout={collageLayout}
          height={collageHeight}
          photos={PHOTOS}
          showNumOfRemainingPhotos
        />
      )}

      <h1>Gift Voucher Available</h1>
      <BookNowBtn style={classes.bookNowBtnStyle} />

      <FooterInfo style={classes.footerStyle} />
      <FloatingButton />
    </div>
  );
};

export default AboutUs;
